<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">添加油卡</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()" />
    </div>
    <!-- 返回 结束 -->
    <!-- 新增油卡顶部 开始 -->
    <div class="page_tab">
      <div class="page_tablist" v-for="(item,index) in tabHead" @click="changetabs(index)">
        <div :class="item.select ? 'page_tabname':'page_tabname1'">{{item.name}}</div>
      </div>
    </div>
    <!-- 新增油卡顶部 结束 -->
    <!-- 新增油卡banner 开始 -->
    <div class="page_top"></div>
    <!-- 新增油卡banner 结束 -->
    <!-- 转让表单  开始 -->
    <!-- 确认卡号 开始 -->
    <!-- <input class="page_checkinput" placeholder="请输入确认卡号" v-model="cardNumConfirm" /> -->
    <div class="page_taocan oiladd_taocan1" v-if="isconfirm">
      <div class="page_inputfrom oiladd_input">
        <div class="oiladd_checktitle">确认卡号:</div>

        <input class="page_checkinput" style="width: 220px;" v-model="cardNumConfirm" placeholder="请输入确认卡号" @input="formatCardNumber1"
          ref="cardInput" />
      </div>
    </div>
    <!-- 确认卡号 结束 -->
    <div class="page_taocan oiladd_taocan" v-else>
      <div class="page_inputfrom oiladd_input1">
        <div class="oiladd_checktitle">加油卡号:</div>
        <input class="page_checkinput" :type="confirm ? 'password' : 'text'" style="width: 220px;" v-model="cardNum" :placeholder="isSinopec==0 ? '100011开头非副卡' : '9030、9000、9088开头非BP卡、副卡' "
          @input="formatCardNumber" @focus="foucs" ref="cardInput" />
        <!-- <input class="page_checkinput" :placeholder="isSinopec==0 ? '100011开头非副卡' : '9030、9000、9088开头非BP卡、副卡' " v-model="cardNum" /> -->
      </div>
      <div class="page_inputfrom oiladd_input">
        <div class="oiladd_checktitle">确认卡号:</div>
        <input class="page_checkinput" @focus="foucs1" style="width: 220px;" v-model="cardNumConfirm" placeholder="请输入确认卡号" @input="formatCardNumber1"
          ref="cardInput" />
        <!-- <input class="page_checkinput" placeholder="请输入确认卡号"v-model="cardNumConfirm" /> -->
      </div>

      <div class="page_inputfrom oiladd_input">
        <div class="oiladd_checktitle">手机号码:</div>
        <input class="page_checkinput" placeholder="请输入可接收通知手机号码" v-model="phoneNum" />
      </div>
   <!--   <div class="page_inputfrom oiladd_input">
        <div class="oiladd_checktitle1">持卡人:</div>
        <input class="page_checkinput" placeholder="请输入持卡人姓名(选填)" v-model="name" />
      </div> -->
      <div class="tip-data">提示：请核实卡号，充错不予退回</div>
    </div>
    <!-- 转让表单  结束 -->
    <!-- 提交 开始 -->
    <div class="page_button oiladd_button" @click="addCard()">
      <div class="page_zhifu">添加</div>
    </div>
    <!-- <div class="page_button oiladd_button" @click="isconfirm?addCard(): toconfirm()">
      <div class="page_zhifu">{{isconfirm ? '添加' : '确认'}}</div>
    </div> -->
    <!-- 提交 结束 -->
    <!-- 注意事项 开始 -->
    <div class="page_mesg">
      <div class="page_mesgtitle">
        <img class="page_mesgimg" src="/static/newprojecticon/title.png" />
        <div class="page_mesgtext">注意事项</div>
      </div>
      <div class="page_mesgtip">本平台加油卡充值仅支持中石化、中石油卡充值</div>
      <div class="page_mesgtip">充值开放时间为法定工作日8:30～17:30，预计到账时间为提交订单后3个工作日内</div>
      <div class="page_mesgtip">客服热线：<a :href="'tel:' + telNumber">{{telNumber}}</a></div>
    </div>
  </div>
  <!-- 注意事项 结束 -->
</template>
<script>
  // import swal from 'sweetalert'
  import httper from '../../api/http'
  import {
    Dialog
  } from 'vant';
  import axios from 'axios'
  export default {
    data() {
      return {
        tabHead: [{
          name: "中国石化",
          select: true
        }, {
          name: "中国石油",
          select: false
        }],
        tabHeadIndex: 0,
        cardNum: '', // 加油卡号,默认为空
        cardNumConfirm: '', // 确认卡号,默认为空
        name: '', // 持卡人,默认为空
        phoneNum: '', // 手机号码,默认为空
        showTopTips1: false, // 错误提示(加油卡号格式错误),默认为false
        showTopTips2: false, // 错误提示(加油卡号与确认卡号不一致),默认为false
        showTopTips3: false, // 错误提示(持卡人格式错误),默认为false
        showTopTips4: false, // 错误提示(手机号码格式错误),默认为false
        isSinopec: 0, // 用户是否点击选中中石化,默认为false
        phonetext: '400-8812-336', // 服务热线、客服电话
        buttonClicked: false, // 防止重复点击,默认为false
        getYouCard: [], //调用添加油卡后后台返回的数据，默认为空
        telNumber: "", //客服电话
        isconfirm: false, //是否跳转确认卡号
        testData: '',
        confirm:false
      }
    },
    created() {
      this.telNumber = localStorage.getItem("phoneNumber")
    },
    mounted() {

    },
    methods: {
      pageReturn() {
        this.$router.go(-1)
      },
      pageToIndex() {
        this.$router.push({
          path: "/"
        })
      },
      /**
       * 防重点击
       * @param duration
       * @returns {Promise<any>}
       */
      buttonClickedFun(duration = 0) {
        this.buttonClicked = true
        return new Promise((resolve, reject) => {
          if (duration && typeof duration === 'number') {
            setTimeout(() => {
              this.buttonClicked = false
            }, duration)
          }
          resolve(true)
        })
      },
      tap(e) {

      },
      // 格式化卡号显示，每4位加空格
      formatCardNumber(e) {

        // 获取input的dom对象
        const input = e.target
        // 获取当前光标的位置
        const cursorIndex = input.selectionStart
        // 字符串中光标之前空格的个数
        const lineNumOfCursorLeft = (e.target.value.slice(0, cursorIndex).match(/\s/g) || []).length
        // 去掉所有空格的字符串
        const noLine = e.target.value.replace(/\s/g, '')
        // 去除格式不对的字符并重新插入空格的字符串
        const newCardNum = noLine.replace(/\D+/g, '').replace(/(\d{4})/g, '$1 ').replace(/\s$/, '')
        // 改后字符串中原光标之前空格的个数
        const newLineNumOfCursorLeft = (newCardNum.slice(0, cursorIndex).match(/\s/g) || []).length
        // 光标在改后字符串中应在的位置
        const newCursorIndex = cursorIndex + newLineNumOfCursorLeft - lineNumOfCursorLeft
        // 赋新值，nextTick保证空格不能手动输入或删除，只能按照规则自动填入
        this.$nextTick(() => {
          this.cardNum = newCardNum
          // 修正光标位置，nextTick保证在渲染新值后定位光标
          this.$nextTick(() => {
            // selectionStart、selectionEnd分别代表选择一段文本时的开头和结尾位置
            input.selectionStart = newCursorIndex
            input.selectionEnd = newCursorIndex
          })
        })
      },
      foucs(){
        this.confirm=false
      },
      foucs1(){
        this.confirm=true
      },
      // 格式化卡号显示，每4位加空格
      formatCardNumber1(e) {

        // 获取input的dom对象
        const input = e.target
        // 获取当前光标的位置
        const cursorIndex = input.selectionStart
        // 字符串中光标之前空格的个数
        const lineNumOfCursorLeft = (e.target.value.slice(0, cursorIndex).match(/\s/g) || []).length
        // 去掉所有空格的字符串
        const noLine = e.target.value.replace(/\s/g, '')
        // 去除格式不对的字符并重新插入空格的字符串
        const newCardNum = noLine.replace(/\D+/g, '').replace(/(\d{4})/g, '$1 ').replace(/\s$/, '')
        // 改后字符串中原光标之前空格的个数
        const newLineNumOfCursorLeft = (newCardNum.slice(0, cursorIndex).match(/\s/g) || []).length
        // 光标在改后字符串中应在的位置
        const newCursorIndex = cursorIndex + newLineNumOfCursorLeft - lineNumOfCursorLeft
        // 赋新值，nextTick保证空格不能手动输入或删除，只能按照规则自动填入
        this.$nextTick(() => {
          this.cardNumConfirm = newCardNum
          // 修正光标位置，nextTick保证在渲染新值后定位光标
          this.$nextTick(() => {
            // selectionStart、selectionEnd分别代表选择一段文本时的开头和结尾位置
            input.selectionStart = newCursorIndex
            input.selectionEnd = newCursorIndex
          })
        })
      },
      changetabs(e) {
        let that = this
        let tabHead = that.tabHead
        tabHead.map((item, index) => item.select = index === Number(e))
        that.tabHeadIndex = Number(e)
        this.isSinopec = e
      },
      // 点击切换中石化/中石油
      changeSinopec(e) {
        this.isSinopec = e
      },
      tapindex() {
        this.$router.push({
          path: '/'
        })
      },
      //点击确认卡号
      toconfirm() {
        let that = this
        // let name = this.name.replace(
        //   /[^\u2E80-\u2EFF\u2F00-\u2FDF\u3000-\u303F\u31C0-\u31EF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FBF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF]+/g,
        //   '')
        // 卡号长度或格式错误时顶部显示错误提示2秒
        if (String(that.cardNum).length < 16) {
          this.$toast({
            message: '卡号格式错误',
          })
          return
        }
        // 姓名长度或格式错误时顶部显示错误提示2秒

        // if (name.length == 0) {
        //   this.$toast({
        //     message: '名长度或格式错误',
        //   })
        //   return
        // }
        // 手机号码格式错误时顶部显示错误提示2秒
        if (!/^1[0-9]{10}$/.test(that.phoneNum)) {
          this.$toast({
            message: '手机号码格式错误',
          })
          return
        }
        console.log("确认")
        that.isconfirm = true
      },
      // 点击添加油卡(待施工
      addCard() {
        // 防止重复点击
        this.buttonClickedFun(1000)
        let that = this
        // let name = this.name.replace(
        //   /[^\u2E80-\u2EFF\u2F00-\u2FDF\u3000-\u303F\u31C0-\u31EF\u3200-\u32FF\u3300-\u33FF\u3400-\u4DBF\u4DC0-\u4DFF\u4E00-\u9FBF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF]+/g,
        //   '')
        console.log('是 中石化 吗？', that.isSinopec)
        console.log('加油卡号：', that.cardNum)
        console.log('确认卡号：', that.cardNumConfirm)
        //console.log('持卡人：', name)
        //console.log('持卡人长度：', name.length)
        console.log('手机号码：', that.phoneNum)



        // 卡号长度或格式错误时顶部显示错误提示2秒(待施工)
        if (String(that.cardNum).length < 16) {
          this.$toast({
            message: '卡号格式错误',
          })
          return
        }
        // 卡号与确认卡号不一致时顶部显示错误提示2秒(待施工)
        if (that.cardNum != that.cardNumConfirm) {
          this.$toast({
            message: '卡号与确认卡号不一致',
          })
          that.isconfirm = false
          return
        }
        // 姓名长度或格式错误时顶部显示错误提示2秒
        // if (name.length == 0) {
        //   this.$toast({
        //     message: '名长度或格式错误',
        //   })
        //   return
        // }
        // 手机号码格式错误时顶部显示错误提示2秒
        if (!/^1[0-9]{10}$/.test(that.phoneNum)) {
          this.$toast({
            message: '手机号码格式错误',
          })
          return
        }
        //调用添加油卡的接口
        //去除空格
        var cardNum_str = that.cardNum.replace(/\s*/g, "");
        console.log(cardNum_str);
        if (that.isSinopec == 0) {
          let requestData = {
            card_no: '' + cardNum_str,
            brand: 1,
            cardholder: '' + name,
            mobile: '' + that.phoneNum
          }
          // let requestData1 = JSON.stringify(requestData)
          // console.log('requestData1 ',requestData1 )
          that.request('bindYouCard', requestData)
          //   axios.get(process.env.API_HOST +'/user/add-oil-card',{ params:{  card_no: '' + that.cardNum,brand: 1,cardholder: '' + name ,mobile: '' + that.phoneNum } })
          // .then(function (val) {
          //     if (val.data.code == 0) {
          //        that.featureList = val.data.data
          //     }else {
          //     swal('res.data.message','success')
          //     }
          // })

        } else {
          let requestData = {
            card_no: '' + cardNum_str,
            brand: 2,
            cardholder: '' + name,
            mobile: '' + that.phoneNum
          }
          that.request('bindYouCard', requestData)
        }
      },
      //调接口封装
      request(type, requestData = {}) {
        let that = this
        switch (type) {
          case 'bindYouCard':
            httper.post('user/add-oil-card', requestData, res => {
              if (res.code === 0) {
                // swal({
                //   text: '添加油卡成功'
                // })
                this.$toast({
                  message: '添加油卡成功',
                })
                // that.$router.push({ path: '/taoyao' })
                that.$router.go(-1);
              } else {
                // swal({
                //   text: res.message
                // })
                this.$toast({
                  message: res.message,
                })
              }
            }, true)
            break
        }
      },
    }
  }
</script>
<style scoped>
  .oiladd_taocan {
    /* height: 268px;
    top: 88px; */
    /* height: 194px;
    top: 140px; */
    height: 100%;
  }

  .oiladd_taocan1 {
    height: 100%;
    /* height: 80px;
    top: 210px; */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ::-webkit-input-placeholder {
    text-align: start;
    color: rgba(187, 187, 187, 1);
    font-size: 14px;
  }

  .oiladd_input1 {
    margin: 20px 20px 40px 20px;
  }

  .oiladd_input {
    margin: 40px 20px;
  }

  .oiladd_checktitle {
    margin-right: 20px;
  }

  .oiladd_checktitle1 {
    margin-right: 34px;
  }

  .oiladd_button {
    /* margin-top: 152px; */
  }
  .tip-data{
    font-size: 14px;
    color: red;
    margin-left: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/oilcard/oilCardAdd.vue